import { render, staticRenderFns } from "./distributorCharges.vue?vue&type=template&id=28d7bffa&scoped=true"
import script from "./distributorCharges.vue?vue&type=script&lang=js"
export * from "./distributorCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d7bffa",
  null
  
)

export default component.exports